export default __webpack_public_path__ + "static/media/polegarPositivoIcone.3c22628c.svg";